import { useState } from 'react';
import { UseQueryResult } from '@tanstack/react-query';
import S from './ReportRequestStyles';
import Icon from '../Icon/Icon';
import { IconKeys } from '../Icon/IconKeys';
import Modal from '../Modal/Modal';
import File from './File';
import { FeaturesManagement } from '../../../featuresControl';

type Props = {
  name?: string;
  endpoint: (fleetId: string, query: string) => UseQueryResult<any>;
  query: string;
  fleetId: string;
};

function ReportRequest({
  name,
  endpoint,
  query,
  fleetId,
}: Props): JSX.Element | null {
  const [confirmModalOpen, toggleConfirmModalOpen] = useState(false);

  if (!FeaturesManagement.features.report) {
    return (null);
  }

  return (
    <S.Wrapper title="Request Report">
      <button type="button" onClick={() => toggleConfirmModalOpen(true)}>
        <Icon iconKey={IconKeys.SUMMARIZE} />
      </button>
      {confirmModalOpen && (
        <Modal
          title="Requesting report"
          state={confirmModalOpen}
          toggleState={toggleConfirmModalOpen}
          settings={{
            minWidth: '500px',
            minHeight: '200px',
          }}
        >
          <File name={name} endpoint={endpoint} query={query} fleetId={fleetId} onDownload={() => toggleConfirmModalOpen(false)} />
        </Modal>
      )}
    </S.Wrapper>
  );
}

export default ReportRequest;
